// src/components/PhoneButton.js
import React from 'react';
import { FaPhoneAlt } from 'react-icons/fa'; // Importing the phone icon from React Icons
import '../styles/components/PhoneButton.css';

const PhoneButton = () => {
  const phoneNumber = '+91 8950533327'; // Replace with your desired phone number

  return (
    <div className="phone-button-container">
      <a href={`tel:${phoneNumber}`} className="phone-button">
        <FaPhoneAlt className='phone-icon' color="#fff" /> {/* React Icon for phone */}
      </a>
    </div>
  );
};

export default PhoneButton;
